<template>
    <div>
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.0001 31.4997C7.43359 31.4997 0.5 24.5577 0.5 16C0.5 7.4331 7.43222 0.5 16.0001 0.5C24.5671 0.5 31.5 7.43216 31.5 16C31.5 24.5659 24.5572 31.4997 16.0001 31.4997Z" fill="#FBFDFE" stroke="#DFE2EB"/>
            <path d="M9.33405 23.0186H22.6676" stroke="#A1A8B8" stroke-width="1.33336" stroke-linecap="round"/>
            <path d="M16.0008 9.33411L9.33405 13.5447H22.6676L16.0008 9.33411Z" stroke="#A1A8B8" stroke-width="1.33336" stroke-linejoin="round"/>
            <path d="M10.6674 14.0009V22.6677" stroke="#A1A8B8" stroke-width="1.33336" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M13.3341 14.0009V22.6677" stroke="#A1A8B8" stroke-width="1.33336" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M18.6675 14.0009V22.6677" stroke="#A1A8B8" stroke-width="1.33336" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M21.3343 14.0009V22.6677" stroke="#A1A8B8" stroke-width="1.33336" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>